var map = {
	"./Film_1.png": "49b9",
	"./Film_2.png": "1324",
	"./Film_3.png": "f7ef",
	"./FindingData_1.png": "af1b",
	"./Mapping_1.png": "9099",
	"./Mapping_2.png": "5974",
	"./Policies_1.png": "969f",
	"./Policies_2.png": "898d",
	"./Stories_1.png": "4b9a",
	"./Stories_2.png": "18ff",
	"./Strategies_1.png": "1218",
	"./Strategies_2.png": "cd6f",
	"./UsingData_1.png": "8116",
	"./UsingData_2.png": "827d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0abe";